import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import { AuthStore } from 'stores';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

const FacebookAccess = ({
    label,
    onResponse,
    onSuccess,
    theme,
    block,
    size,
    onError,
    submitting,
    setSubmitting,
    isLogin,
}) => {
    const auth = useContext(AuthStore);

    const onFacebookResponse = (res) => {
        if (submitting) {
            return;
        }
        setSubmitting(true);

        isLogin
            ? auth.facebookLogin(res).then(onSuccess).catch(onError)
            : auth.facebookSignup(res).then(onSuccess).catch(onError);
    };

    return (
        <FacebookLogin
            fields="name,email,picture"
            scope="user_friends,public_profile,email"
            appId={window.yconfig.facebookAppId}
            callback={onResponse ? onResponse : onFacebookResponse}
            cookie={true}
            isMobile={false}
            disableMobileRedirect={true}
            render={(renderProps) => (
                <Button
                    data-theme="facebook"
                    onClick={renderProps.onClick}
                    size={size}
                    theme={theme}
                    block={block}
                    fontSize="1.125rem"
                    fontWeight={400}
                >
                    {label}
                </Button>
            )}
        />
    );
};

FacebookAccess.defaultProps = {
    theme: 'facebook',
    size: 'large',
    block: true,
    onResponse: null,
};

FacebookAccess.propTypes = {
    setSubmitting: PropTypes.func.isRequired,
    onResponse: PropTypes.func,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
    theme: PropTypes.string,
    size: PropTypes.string,
    block: PropTypes.bool,
    isLogin: PropTypes.bool,
};

export default FacebookAccess;
